import { endpoint } from "@services/api.services";
import { TableCard } from "@ui/internal/components/card";
import { useHandleAction } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { CertificateWebhookConfigData } from "@utils/interface/journey.interface";
import { useListData } from "@utils/query/index.query";
import { ColumnList } from "./column/index.column";
import CertificateWebhookForm from "./form/index.form";

const CertificateWebhook = () => {
  const { searchParams } = useHandleAction({});

  const {
    data: fetchData,
    isLoading: fetchPending,
    refetch,
  } = useListData<QueryData<CertificateWebhookConfigData>>({
    endpoint: endpoint["certificate-webhook-config"],
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search: searchParams.get("search") || "",
    },
    key: "certificate-webhook-listing",
  });

  const columns = ColumnList({ refetch });

  const rows = Array.isArray(fetchData?.data)
    ? fetchData.data
    : fetchData?.data?.results || [];

  const count = fetchData?.data?.count ?? rows.length;

  return (
    <TableCard
      table_content={{
        mode: "default",
        type: "certificate-webhook",
      }}
      columns={columns}
      rows={rows}
      count={count}
      isPending={fetchPending}
      endpoint={endpoint["certificate-webhook-config"]}
      refetch={refetch}
      form={<CertificateWebhookForm refetch={refetch} />}
    />
  );
};

export default CertificateWebhook;
